import React from "react";
import { StyledTitle } from "./AppTitle.styled";

const AppTitle: React.FC = ({ children }) => {
  return <StyledTitle>{children}</StyledTitle>;
};

export default AppTitle;
